export default __webpack_public_path__ + "static/media/fasting_noworries@3x.a677835b.jpg";